module.exports = __webpack_public_path__ + "img/15.missing_soap.3f917927.svg";